import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, MatDialog, MatDialogRef } from '@angular/material';
import { DialogComponent, Dialog } from '../Components/shared/dialog/dialog.component';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { SharedService } from './shared.service';

@Injectable()

export class NotificationService {
    constructor(
        private _snakBar: MatSnackBar, private _dialog: MatDialog,
        private _http: HttpClient, private _shared: SharedService
    ) {}

    public toastMessage(config: Toast): MatSnackBarRef<any> {
        return this._snakBar.open(config.message, config.button || '', {
            duration: config.duration,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            panelClass: [config.color]
        });
    }

    public openDialog(config: Dialog): MatDialogRef<any> {
        return this._dialog.open(DialogComponent, { data: config, disableClose: true });
    }

    public sendPushNotification(data): Observable<any> {
        return this._http.post<any>(`${this._shared.apiPath}RBSendNotification`, data).pipe(catchError(this._shared.handleError));
    }
}

// Toast type notification
export interface Toast {
    message: string;
    duration: number;
    button?: string;
    color?: 'primary' | 'accent' | 'warn'
}